import React from 'react';
import { List } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import RequestAttachmentLabels from './RequestAttachmentLabels';
import Selectors from '../hooks/selectors';

const RequestAttachmentListItem = ({ category, code }) => {
  const { attachments } = Selectors.useRequestAttachmentListItem({ category, code });
  if (attachments.length === 0) {
    return null;
  }

  return (
    <List.Item className="aridhia-request-attachments-list-item">
      <List.Header>
        <FormattedMessage id="request.list.attachments.title" />
      </List.Header>
      <List.Description className="aridhia-request-attachments-description">
        <RequestAttachmentLabels attachments={attachments} />
      </List.Description>
    </List.Item>
  );
};

export default RequestAttachmentListItem;
